import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import IconButton from '@cotyorg/ccx-molecules/IconButton';
import Input from '@cotyorg/ccx-atoms/Input';
import { getElapsedBarWidth } from './utils';

const generateVolumeControlClassNames = ({ extraClass }) => classNames(
  'cell auto shrink video-player__controls-volume flex-container align-middle',
  extraClass,
);

export const getVolumeMuteIcon = ({
  muted,
  muteIconSrc,
  volumeIconSrc,
}) => (muted ? muteIconSrc : volumeIconSrc);

// istanbul ignore next
const VolumeControl = ({
  id,
  muted,
  muteIconSrc,
  volumeIconSrc,
  title,
  volume,
  setToggleMuted,
  setVolume,
  showOnlyMuteControls,
  extraClass,
}) => (
  <div className={generateVolumeControlClassNames({ extraClass })}>
    <IconButton
      color="transparent"
      extraClass="video-player__controls-btn-icon"
      iconExtraClass="video-player__controls-btn-icon"
      onClick={() => setToggleMuted({ id })}
      iconSrc={getVolumeMuteIcon({ muted, muteIconSrc, volumeIconSrc })}
      title={title}
    />

    {!showOnlyMuteControls ? (
      <div className="video-player__controls-volume-bar video-player__controls-bar flex-container align-middle">
        <Input
          min={0}
          max={1}
          type="range"
          step="any"
          value={volume || 0}
          extraClass="video-player__range flex-container"
          onChange={e => setVolume({ volume: parseFloat(e.target.value), id })}
        />
        <span
          className="video-player__controls-bar--elapsed"
          style={{ width: `${getElapsedBarWidth(volume)}` }}
        />
      </div>
    ) : null}
  </div>
);

VolumeControl.propTypes = {
  id: PropTypes.string.isRequired,
  muted: PropTypes.bool,
  volume: PropTypes.number,
  muteIconSrc: PropTypes.string,
  volumeIconSrc: PropTypes.string,
  setVolume: PropTypes.func,
  setToggleMuted: PropTypes.func,
  title: PropTypes.string,
};

export default VolumeControl;
